import focusVisible from 'focus-visible'
import Fraccordion from 'fr-accordion'
import { lory } from 'lory.js'
import modals from 'Modals'
import offside from 'offside-js'
import '../scss/index.scss'
import tribeSingleEventTweaks from './tribe-single-event'

const activeClass = '-active'
const root = document.documentElement

// Update <html> class to indicate JS is enabled
root.classList.remove('no-js')
root.classList.add('js')

// Polyfill Array.from if needed
if (!Array.from) Array.from = object => [].slice.call(object)

// Activate Lory.js for sliders and read configuration from data-lory
const sliders = [...document.querySelectorAll('[data-lory]')]
sliders.forEach(slider => lory(slider, JSON.parse(slider.dataset.lory || '{}')))

// Tweak the sidebar on single events
if (document.querySelector('body').classList.contains('single-tribe_events')) {
  tribeSingleEventTweaks()
}

// Initialize offcanvas elements, for example:
// <button data-offside="#element-id">Toggle!</button>
const offsideToggles = [...document.querySelectorAll('[data-offside]')]
offsideToggles.forEach(toggle =>
  offside(toggle.dataset.offside, {
    buttonsSelector: toggle,
    afterOpen: () => toggle.classList.add('-is-open'),
    afterClose: () => toggle.classList.remove('-is-open')
  })
)

// Initialize modals on [data-modal] elements
modals.init({
  modalActiveClass: activeClass,
  backspaceClose: false,
  callbackOpen: function startVideoAutoplay(toggle, modal) {
    const iframe = modal.querySelector('iframe')
    if (iframe) {
      const embedUrl = new URL(iframe.src)
      embedUrl.searchParams.set('autoplay', 1)
      iframe.src = embedUrl.toString()
    }
  },
  callbackClose: function stopVideoAutoplay(toggle, modal) {
    const iframe = modal.querySelector('iframe')
    if (iframe) {
      const embedUrl = new URL(iframe.src)
      embedUrl.searchParams.set('autoplay', 0)
      iframe.src = embedUrl.toString()
    }
  }
})

// Make plugins available everywhere
window.frend = {
  accordion: Fraccordion({
    firstPanelsOpenByDefault: false,
    multiselectable: false
  })
}

// Display the fr dropdown selected on the sermon page
const dropdownSelected = document.querySelectorAll('[data-dropdown-selected]')

window.addEventListener('load', () => {
  dropdownSelected.forEach(dropdown => {
    dropdown.click()
  })
})

window.focusVisible = focusVisible
window.lory = lory
